import { isWithinInterval } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { PJM_TZ } from '../index';

export interface IPjmCurrentSeason {
    id: string;
    period: 'summer' | 'winter';
    year: string;
}

/**
 * Summer-2025 -> 01 June 2025 - 31 Oct 2025, May 2026
 * Winter-2026 -> 01 Nov 2025 - 30 Apr 2026
 * Summer-2026 -> 01 June 2026 - 31 Oct 2026, May 2027
 * Winter-2027 -> 01 Nov 2026 - 30 Apr 2027
 * ...
 */
export const getPjmSeasonInfo = (): IPjmCurrentSeason => {
    const currentDate = toZonedTime(new Date().toISOString(), PJM_TZ);
    const currentYear = currentDate.getFullYear();

    // ---- SUMMER (Jun 1 – Oct 31) ----
    const summerStart = toZonedTime(new Date(`${currentYear}-06-01T00:00:00`), PJM_TZ);
    const summerEnd = toZonedTime(new Date(`${currentYear}-10-31T23:59:59.999`), PJM_TZ);

    if (isWithinInterval(currentDate, { start: summerStart, end: summerEnd })) {
        return {
            id: `summer-${currentYear + 1}`,
            period: 'summer',
            year: `${currentYear + 1}`,
        };
    }

    // ---- SUMMER (May) ----
    const mayStart = toZonedTime(new Date(`${currentYear}-05-01T00:00:00`), PJM_TZ);
    const mayEnd = toZonedTime(new Date(`${currentYear}-05-31T23:59:59.999`), PJM_TZ);

    if (isWithinInterval(currentDate, { start: mayStart, end: mayEnd })) {
        return {
            id: `summer-${currentYear}`,
            period: 'summer',
            year: `${currentYear}`,
        };
    }

    // ---- WINTER (Jan 1 - Apr 30) ----
    const winterStart = toZonedTime(new Date(`${currentYear}-01-01T00:00:00`), PJM_TZ);
    const winterEnd = toZonedTime(new Date(`${currentYear}-04-30T23:59:59.999`), PJM_TZ);

    if (isWithinInterval(currentDate, { start: winterStart, end: winterEnd })) {
        return {
            id: `winter-${currentYear}-${currentYear + 1}`,
            period: 'winter',
            year: `${currentYear}-${currentYear + 1}`,
        };
    }

    // ---- WINTER (Nov 1 – Dec 31) ----
    return {
        id: `winter-${currentYear + 1}-${currentYear + 2}`,
        period: 'winter',
        year: `${currentYear + 1}-${currentYear + 2}`,
    };
};
